import { render, staticRenderFns } from "./LpUserCard.vue?vue&type=template&id=056aa147"
import script from "./LpUserCard.vue?vue&type=script&lang=js"
export * from "./LpUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports